import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";


export class ReadingPlanService {
	public static readingPlanSave(input: any) {
		return Http.axios().post('/api/ReadingPlan/add', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {
					return res;
				}).catch((e: any) => {
					return e.response;
				});
	}

	public static readingPlanGetByFilter(input: any) {
		return Http.axios().post('/api/ReadingPlan/getbyfilter', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static readingPlanGetDetail(input: any) {
		return Http.axios().post('/api/ReadingPlanDay/getbyfilter', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static readingPlanDelete(input: any) {
		return Http.axios().delete('/api/ReadingPlan/delete/' + input, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static readingPlanDaySave(input: any) {
		return Http.axios().post('/api/ReadingPlanDay/addorupdate', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static readingPlanCopy(input: any) {
		return Http.axios().post('/api/ReadingPlan/copyreadingplan', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static readingPlanDayDelete(input: any) {
		return Http.axios().delete('/api/ReadingPlanDay/delete/' + input, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}